import { createConsumer, Consumer } from "@rails/actioncable";

let consumer: Consumer | null = null;
let activeUrl: string | null = null;

const FALLBACK_CABLE_PATH = "/cable";

function getCableUrl() {
  const el = document.querySelector(`meta[name="action-cable-url"]`);
  return el?.getAttribute("content") || FALLBACK_CABLE_PATH;
}

export function getConsumer(): Consumer {
  const url = getCableUrl();

  // If active module has changed, disconnect and reset with new
  if (consumer && activeUrl !== url) {
    consumer.disconnect();
    consumer = null;
    activeUrl = null;
  }

  if (!consumer) {
    consumer = createConsumer(url);
    activeUrl = url;
  }

  return consumer;
}
